import React from 'react';
export function JealousFooter() {
  return <footer className="w-full py-12 px-4 pb-32 lg:pb-12" style={{
    backgroundColor: '#0F2D4A'
  }} data-id="element-265">
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center gap-6" data-id="element-266">
        <div className="flex items-center gap-3" data-id="element-267">
          <img src="https://cdn.magicpatterns.com/uploads/maRSH6M7GLaZ9GWdxKsXjo/BlueCactus_Power_Washing_Icon_6.svg" alt="Blue Cactus" className="h-10 w-10" data-id="element-268" />
          <h3 style={{
          color: '#FFFFFF',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 800,
          fontSize: '18px'
        }} data-id="element-269">
            Blue Cactus Power Washing
          </h3>
        </div>
        <div className="flex items-center gap-6" data-id="element-270">
          <a href="#" className="transition-opacity hover:opacity-100" style={{
          color: 'rgba(255,255,255,0.6)',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontSize: '13px'
        }} data-id="element-271">
            Privacy Policy
          </a>
          <a href="#" className="transition-opacity hover:opacity-100" style={{
          color: 'rgba(255,255,255,0.6)',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontSize: '13px'
        }} data-id="element-272">
            Terms of Service
          </a>
        </div>
        <p style={{
        color: 'rgba(255,255,255,0.4)',
        fontFamily: '"Plus Jakarta Sans", sans-serif',
        fontSize: '13px'
      }} data-id="element-273">
          © 2026 Blue Cactus Power Washing. All rights reserved.
        </p>
      </div>
    </footer>;
}